module.exports = __webpack_public_path__ + "img/Partners 5.2ad0e956.png";